import { useQuery, UseQueryOptions } from '@tanstack/react-query';

import { useCurrentOrg } from '@/features/org/hooks/use-org';
import {
  getPartners,
  PartnerPopulated,
} from '@/features/partners/api/get-partners';
type Props = UseQueryOptions<PartnerPopulated[], unknown, PartnerPopulated[]>;

const partnersQueryKey = (orgId?: number) => ['partners', orgId];

export const usePartners = (props?: Props) => {
  const { data: org, isLoading: isOrgLoading } = useCurrentOrg();
  return useQuery({
    ...props,
    queryKey: partnersQueryKey(org?.id),
    queryFn: async () => {
      if (isOrgLoading || !org) {
        return [] as PartnerPopulated[];
      }
      return await getPartners(org.id);
    },
    enabled: !isOrgLoading && !!org,
  });
};
